import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import moment from 'moment';
import store from '@/vue/store';
import ClickOutside from 'vue-click-outside';
import sleep from 'sleep-promise';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
var namespace = 'news-store';
export default {
  store: store,
  directives: {
    ClickOutside: ClickOutside
  },
  data: function data() {
    return {
      showMenu: false
    };
  },
  computed: _objectSpread({}, mapState(namespace, ['shops']), {}, mapGetters(namespace, ['hasShopEntries']), {
    ariaExpanded: function ariaExpanded() {
      if (this.showMenu) {
        return true;
      } else {
        return false;
      }
    }
  }),
  methods: _objectSpread({}, mapActions(namespace, ['getNewList', 'setShop']), {}, mapMutations(namespace, ['setPage']), {
    changeShop: function () {
      var _changeShop = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(shop) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setPage(1);
                this.setShop(shop);
                _context.next = 4;
                return sleep(100);

              case 4:
                this.getNewList();
                this.closeMenu();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function changeShop(_x) {
        return _changeShop.apply(this, arguments);
      }

      return changeShop;
    }(),
    toggleMenu: function toggleMenu() {
      this.showMenu = !this.showMenu;
    },
    closeMenu: function closeMenu() {
      this.showMenu = false;
    }
  })
};